import { request } from '@/utils/request'
export default {
    bannerList: (params, loading) => {
        return request('/api/web/carouse/list', params, loading)
    },
    businessInfo: (params, loading) => {
        return request('/api/web/mainbus', params, loading)
    },
    proShow: (params, loading) => {
        return request('/api/web/minepro', params, loading)
    },





    bannerEdit: (params, loading) => {
        return request('/api/slideshow/update', params, loading)
    },
    bannerDel: (params, loading) => {
        return request('/api/slideshow/del', params, loading)
    },
    businessSave: (params, loading) => {
        return request('/api/businessmainprocess/save', params, loading)
    },
    proAdd: (params, loading) => {
        return request('/api/mineproduct/add', params, loading)
    },
    proEdit: (params, loading) => {
        return request('/api/mineproduct/edit', params, loading)
    },
    proDelApi: (params, loading) => {
        return request('/api/mineproduct/del', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/homeView.js